import * as actionTypes from '../../actionTypes';

// utilities
import _ from 'lodash';

// initial state
export const initialState = {};


export default function workObjectivesReducer(state = initialState, {type, workObjectives}) {
  switch (type) {
    case actionTypes.UPDATE_APPLICANT_WORK_OBJECTIVES :
      // need to use assign to handle logout
      return _.merge({}, state, workObjectives);
    case actionTypes.UPDATE_APPLICANT :
        return _.merge({}, state, workObjectives);

    case actionTypes.CLEAR_APPLICANT :
    case actionTypes.LOG_OUT :
      return {};

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./shared/redux/reducers/workObjectives/index.js